import React from 'react';
import PropTypes from 'prop-types';
import { Modal as BaseModal } from 'react-bootstrap';

import Form from './Form';

export default function Modal({ row, show, onHide }) {
  return (
    <BaseModal
      className="student inmodal auto without-overflow"
      show={show}
      onHide={onHide}
    >
      <BaseModal.Header closeButton>
        <BaseModal.Title>Edit a Webinar</BaseModal.Title>
      </BaseModal.Header>

      <BaseModal.Body>
        <Form row={row} onHide={onHide} />
      </BaseModal.Body>
    </BaseModal>
  );
}

Modal.propTypes = {
  row: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
};
